// Central route-permission matrix — 2026-02-21.
// Mirror of `backend/route_permissions.py`. If they drift, run the audit
// endpoint /api/admin/route-permissions/audit which returns both server &
// client matrices side by side.
//
// Enforcement: use `useCanAccess(capability)` inside a page, or wrap with
// `<RequireCapability capability="…">`. On denial, render <AccessRestricted>
// — NEVER a silent <Navigate> away from the URL.

export const CAPABILITY_MATRIX = {
    // Billing / money surfaces — ACCOUNT_ADMIN only.
    "billing.view":                    ["ACCOUNT_ADMIN"],
    "billing.subscribe":               ["ACCOUNT_ADMIN"],
    "billing.cancel":                  ["ACCOUNT_ADMIN"],
    "billing.rate_card":               ["ACCOUNT_ADMIN"],
    "wallet.view":                     ["ACCOUNT_ADMIN"],
    "wallet.topup":                    ["ACCOUNT_ADMIN"],
    "wallet.transactions":             ["ACCOUNT_ADMIN"],
    "job.boost":                       ["ACCOUNT_ADMIN"],

    // Team management — ACCOUNT_ADMIN only.
    "team.view":                       ["ACCOUNT_ADMIN"],
    "team.invite":                     ["ACCOUNT_ADMIN"],
    "team.update":                     ["ACCOUNT_ADMIN"],
    "team.deactivate":                 ["ACCOUNT_ADMIN"],
    "team.assign_jobs":                ["ACCOUNT_ADMIN"],

    // Company profile — HMs view, ADMIN edits.
    "company_profile.view":            ["ACCOUNT_ADMIN", "HIRING_MANAGER"],
    "company_profile.edit":            ["ACCOUNT_ADMIN"],
    "company_profile.gstin":           ["ACCOUNT_ADMIN"],

    // Usage — ACCOUNT_ADMIN only.
    "usage.view":                      ["ACCOUNT_ADMIN"],

    // Jobs — HMs create & edit assigned.
    "job.create":                      ["ACCOUNT_ADMIN", "HIRING_MANAGER"],
    "job.edit":                        ["ACCOUNT_ADMIN", "HIRING_MANAGER"],
    "job.delete":                      ["ACCOUNT_ADMIN"],
    "job.publish":                     ["ACCOUNT_ADMIN", "HIRING_MANAGER"],
    "job.slots":                       ["ACCOUNT_ADMIN", "HIRING_MANAGER"],
    "job.pipeline":                    ["ACCOUNT_ADMIN", "HIRING_MANAGER"],
    "job.campaigns":                   ["ACCOUNT_ADMIN", "HIRING_MANAGER"],
    "job.screening_builder":           ["ACCOUNT_ADMIN", "HIRING_MANAGER"],

    // Applications / pipeline.
    "application.view":                ["ACCOUNT_ADMIN", "HIRING_MANAGER", "INTERVIEWER"],
    "application.stage_change":        ["ACCOUNT_ADMIN", "HIRING_MANAGER"],
    "application.rate":                ["ACCOUNT_ADMIN", "HIRING_MANAGER", "INTERVIEWER"],

    // Dashboard entry.
    "dashboard.view":                  ["ACCOUNT_ADMIN", "HIRING_MANAGER", "INTERVIEWER"],
};

function allowedRoles(capability) {
    const list = CAPABILITY_MATRIX[capability];
    if (!list) return ["ACCOUNT_ADMIN"]; // deny-by-default for unknown caps
    if (!list.includes("ACCOUNT_ADMIN")) return [...list, "ACCOUNT_ADMIN"];
    return list;
}

export function canAccess(teamRole, capability) {
    return allowedRoles(capability).includes(teamRole || "");
}

export function minRolesFor(capability) {
    return allowedRoles(capability);
}
